import { mapGetters } from 'vuex'

function UserContainer (Comp) {
  return {
    data () {
      return {
        isUserGroupList: false,
        isSnsList: false,
        isGroupList: false
      }
    },
    computed: {
      ...mapGetters('code', ['userGroupList', 'snsList']),
      ...mapGetters('customer', ['groupList']),
      ...mapGetters('user', ['userInfo'])
    },
    render (h) {
      if (this.isUserGroupList && this.isSnsList) {
        return h(Comp)
      }

      return null
    },
    watch: {
      userGroupList: {
        handler (value) {
          if (value.length > 0) {
            this.isUserGroupList = true
          }
        },
        immediate: true
      },
      snsList: {
        handler (value) {
          if (value.length > 0) {
            this.isSnsList = true
          }
        },
        immediate: true
      },
      groupList: {
        handler (value) {
          if (value.length > 0) {
            this.isGroupList = true
          }
        },
        immediate: true
      }
    }
  }
}

export default UserContainer



// WEBPACK FOOTER //
// ./src/pages/user/UserContainer.js